import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import './Login.scss';
import { Button, FormHelperText } from '@mui/material';
import { RestApi } from '../../services/restapi.service';
import { TokenService } from '../../services/token.service';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';

const LoginSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required().min(5)
});

export default function Login() {
    const navigate = useNavigate();
    const [loginFailure, setLoginFailure] = useState(false);
    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validateOnMount: true,
        onSubmit: async (values) => {
            try {
                setLoginFailure(false);
                const res = await RestApi.login(values.email, values.password);
                TokenService.setToken(res.data.token);
                navigate('/');
            } catch (error) {
                console.log('err', error);
                setLoginFailure(true);
            }
        },
        validationSchema: LoginSchema
    });
    const isLoginDisabled = formik.isSubmitting || !formik.isValid;
    return (
        <div className='Login'>
            <form onSubmit={formik.handleSubmit}>
                <div className='item'>
                    <a href='http://www.gpsatsys.com.au/'>
                        <img className='images' src='assets/images/gpsat.gif' alt='GPSat Logo' height={44} />
                    </a>
                </div>
                <div className='item'>
                    <a href='http://www.gpsatsys.com.au/'>
                        <img className='images' src='assets/images/griffin.gif' alt='GPSat Logo' height={150} />
                    </a>
                </div>
                <div className='item'>
                    <TextField name='email' label='Email' variant='outlined' value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                    {formik.touched.email && formik.errors.email && <FormHelperText error>{formik.errors.email}</FormHelperText>}
                </div>
                <div className='item'>
                    <TextField label='Password' type='password' name='password' variant='outlined' value={formik.values.password} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                    {formik.touched.password && formik.errors.password &&  <FormHelperText error>{formik.errors.password}</FormHelperText>}
                </div>
                <div className='item'>
                    <Button type='submit' variant='outlined' disabled={isLoginDisabled}> Login </Button>
                </div>
                {loginFailure && <FormHelperText error>email or password is wrong</FormHelperText>}
            </form>
        </div>
    );
}
